// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fV","gallery__header":"c-q_fW","gallery__thumbs":"c-q_fX"};